import { Arrow } from "./Arrow";
import { Ellipse } from "./Ellipse";
import { HalfCircle } from "./HalfCircle";
import { Circle } from "./Circle";
import { Heart } from "./Heart";
import { Hexagon } from "./Hexagon";
import { IsoscelesTriangle } from "./IsoscelesTriangle";
import { QuarterCircle } from "./QuarterCircle";
import { Rectangle } from "./Rectangle";
import { RightAngledTriangle } from "./RightAngledTriangle";
import { RightAngledTriangleMirrored } from "./RightAngledTriangleMirrored";
import { RoundedRectangle } from "./RoundedRectangle";
import { SlopedRectangle } from "./SlopedRectangle";
import { ArchedRectangle } from "./ArchedRectangle";
import { Text } from "./Text";
import { Trapezoid } from "./Trapezoid";
import { Star } from "./Star";
import { DXF } from "./DXF";
import AbstractShape from "./AbstractShape";
import { IModel } from "makerjs";
import { FlatOval } from "./FlatOval";
import { SlopedRightRectangle } from "./SlopedRightRectangle";
import { Octagon } from "./Octagon";
import { Droplet } from "./Droplet";
import { Polygon } from "./Polygon";
import { Egg } from "./Egg";
import { Kite } from "./Kite";
import { Barrel } from "./Barrel";
import { Jewel } from "./Jewel";
import { Parallelogram } from "./Parallelogram";
import { SlopedRectangleFlipHorizontal } from "./SlopedRectangleFlipHorizontal";
import { SlopedRightRectangleFlipVertical } from "./SlopedRightRectangleFlipVertical";
import { ParallelogramFlipHorizontal } from "./ParallelogramFlipHorizontal";

interface PreviewShapeFactoryParameters {
	shape: string;
	dimensions?: object;
	modifiers?: object;
	fonts?: object;
	model?: IModel;
}

export class PreviewShapeFactory {
	get( { shape, dimensions, modifiers, fonts, model = null }: PreviewShapeFactoryParameters ): AbstractShape {
		let instance = null;

		switch (shape) {
			case 'rectangle':
				instance = new Rectangle( dimensions );
				break;
			case 'right-angled-triangle':
				instance = new RightAngledTriangle( dimensions );
				break;
			case 'right-angled-triangle-mirrored':
				instance = new RightAngledTriangleMirrored( dimensions );
				break;
			case 'rounded-rectangle':
				instance = new RoundedRectangle( dimensions, modifiers );
				break;
			case 'egg':
				instance = new Egg( dimensions );
				break;
			case 'ellipse':
				instance = new Ellipse( dimensions );
				break;
			case 'flat-oval':
				instance = new FlatOval( dimensions );
				break;
			case 'isosceles-triangle':
				instance = new IsoscelesTriangle( dimensions );
				break;
			case 'quarter-circle':
				instance = new QuarterCircle( dimensions );
				break;
			case 'half-circle':
				instance = new HalfCircle( dimensions );
				break;
			case 'circle':
				instance = new Circle( dimensions );
				break;
			case 'star':
				instance = new Star( dimensions, modifiers );
				break;
			case 'hexagon':
				instance = new Hexagon( dimensions );
				break;
			case 'octagon':
				instance = new Octagon( dimensions );
				break;
			case 'polygon':
				instance = new Polygon( dimensions, modifiers );
				break;
			case 'arrow':
				instance = new Arrow( dimensions );
				break;
			case 'heart':
				instance = new Heart( dimensions );
				break;
			case 'sloped-rectangle':
				instance = new SlopedRectangle( dimensions );
				break;
			case 'sloped-rectangle-flip-horizontal':
				instance = new SlopedRectangleFlipHorizontal( dimensions );
				break;
			case 'sloped-right-rectangle':
				instance = new SlopedRightRectangle( dimensions );
				break;
			case 'sloped-right-rectangle-flip-vertical':
				instance = new SlopedRightRectangleFlipVertical( dimensions );
				break;
			case 'arched-rectangle':
				instance = new ArchedRectangle( dimensions );
				break;
			case 'trapezoid':
				instance = new Trapezoid( dimensions );
				break;
			case 'kite':
				instance = new Kite( dimensions );
				break;
			case 'barrel':
				instance = new Barrel( dimensions );
				break;
			case 'jewel':
				instance = new Jewel( dimensions );
				break;
			case 'droplet':
				instance = new Droplet( dimensions );
				break;
			case 'parallelogram':
				instance = new Parallelogram( dimensions );
				break;
			case 'parallelogram-flip-horizontal':
				instance = new ParallelogramFlipHorizontal( dimensions );
				break;
			case 'text':
				instance = new Text( dimensions, fonts, modifiers );
				break;
			case 'dxf':
				instance = new DXF( model );
				break;
		}

		if (instance !== null) {
			instance.createModel();
		}

		return instance;
	}
}
